import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import {
  Center, Container, Table, Title, Text,
} from '@mantine/core';

import * as classes from './TabellaContenuti.module.css';
import ButtonBlock from '../ButtonBlock';


function TabellaContenuti({ titolo, buttons, righe }) {
  const intestazioniUsate = useMemo(() => (
    righe.map((int) => (
      Object.keys(int)
        .filter((i) => (i.match(/^tabellaRigaColonna\d+$/)))
        .map((i) => (parseInt(i.replace(/^tabellaRigaColonna/, ''), 10)))
        .sort((a, b) => (a - b))
        .filter((key) => (int[`tabellaRigaColonna${key}`]))
    ))
  ), [righe]);

  return (
    <Container>
      {titolo && <Title order={3} mt="xl" mb="xl" ta="center">{titolo}</Title>}
      <Table
        withTableBorder
        verticalSpacing="md"
        striped
        withColumnBorders
        className={classes.table}
      >
        <Table.Tbody>
          {intestazioniUsate.map((intestazione, key) => {
            const Comp = righe[key]?.tabellaRigaIntestazione ? Table.Th : Table.Td;

            // ricavo le intestazioni
            const righeConIntestazioni = righe
              .map((r, key) => ({ ...r, key }))
              .filter(({ tabellaRigaIntestazione, key: k }) => (k < key && tabellaRigaIntestazione))
              .map((r) => (intestazioniUsate[key]
                .reduce((acc2, i, kk) => {
                  if (r[`tabellaRigaColonna${i}`]) {
                    acc2.push(r[`tabellaRigaColonna${i}`].trim());
                  } else if (acc2[kk - 1]) {
                    acc2.push(acc2[kk - 1]);
                  }

                  return acc2;
                }, [])
              ))

            return (
              <Table.Tr key={`licenze_${key + 1}`} className={righe[key]?.tabellaRigaIntestazione ? classes.conintestazione : null}>
                {intestazione.map((i, kk) => (
                  <Comp key={`riga_${key}_colonna_${i}`} colSpan={righe[key][`tabellaRigaColonna${i}Colspan`]}>
                    <Text fw="bold" hiddenFrom="sm">{righeConIntestazioni.map((r) => (r[kk]))?.join(' - ')}</Text>
                    {righe[key][`tabellaRigaColonna${i}`]}
                  </Comp>
                ))}
              </Table.Tr>
            )
          })}
        </Table.Tbody>
      </Table>
      {!!buttons?.length && (
        <Center mt="md" mb="xl">
          <ButtonBlock buttons={buttons} />
        </Center>
      )}
    </Container>
  );
}

TabellaContenuti.propTypes = {
  titolo: PropTypes.string,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      buttonFunction: PropTypes.string,
      buttonLabel: PropTypes.string.isRequired,
      buttonHref: PropTypes.string,
      style: PropTypes.string,
    })
  ),
  TabellaContenuti: PropTypes.arrayOf(
    PropTypes.shape({
      licenzaTitolo: PropTypes.string.isRequired,
      licenzaIsbn: PropTypes.string.isRequired,
      licenzaDurata: PropTypes.string.isRequired,
      licenzaPrezzo: PropTypes.string.isRequired,
    })
  )
};

export default TabellaContenuti;
